import React, { memo, useContext } from "react";

import { MenuItem, TableCell, TableRow, TextField } from "@mui/material";

import { useState } from "react";
import { withRouter } from "react-router";
import ButtonsAction from "../../../components/Tablas/ButtonsAction";
import AuthContext from "../../../../Context/Auth/AuthContext";
import { Cancel, Check } from "@mui/icons-material";

import { trimPropsItem } from "../../../../config/const";
import {
  useRowStyles,
  butonIconTransition,
} from "../../../../styles/stylesRows";
import { objectDefault } from "../data";

const Row = (props) => {
  // CLASES
  const classes = useRowStyles();
  // PROPS
  const { setopen, socket } = props;

  // CONTEXT
  const { usuario } = useContext(AuthContext);
  // COPIA DEL REGISTRO PARA EDITAR

  const [item, setitem] = useState(objectDefault);

  //onChange
  const handleChange = (e) => {
    setitem({ ...item, [e.target.name]: e.target.value });
  };
  // DESHABILITAR BOTON
  const botonDisabled = () => {
    if (item.pb_categoria.trim() === "" || item.pb_parametro.trim() === "") {
      return true;
    }
  };
  // ELIMINAR EL REGISTRO
  const funcSubmit = () => {
    try {
      socket.current.emit(
        "client:guardarData",
        trimPropsItem({
          ...item,
          tabla: "paneles_bioquimica",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          pb_usuario: usuario.usuario,
          pb_empresa: usuario.rucempresa,
        })
      );
      setitem(objectDefault);
      setopen(false);
    } catch (error) {}
  };

  return (
    <React.Fragment>
      <TableRow className={classes.root} component={"form"}>
        {/* boton */}
        <TableCell
          size="small"
          align="center"
          className={classes.celda}
        ></TableCell>
        <ButtonsAction
          botones={[
            {
              tooltip: "Cancelar",
              texto: "",
              funcion: () => {
                setopen(false);
                setitem(objectDefault);
                // setItemEdit(itemHijo);
              },
              disabled: false,
              Icon: Cancel,
              color: "error",
              id: 1,
              ocultar: false,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Guardar",
              texto: "",
              funcion: () => {
                funcSubmit();
              },
              disabled: botonDisabled(),
              Icon: Check,
              color: "success",
              id: 2,
              ocultar: false,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
              submit: true,
            },
          ]}
        />
        <>
          <TableCell size="small" align="center" className={classes.celda}>
            <TextField
              value={item.pb_categoria}
              name="pb_categoria"
              onChange={(e) => handleChange(e)}
              size="small"
              fullWidth
            />
          </TableCell>
          <TableCell size="small" align="center" className={classes.celda}>
            <TextField
              value={item.pb_parametro}
              name="pb_parametro"
              onChange={(e) => handleChange(e)}
              size="small"
              fullWidth
            />
          </TableCell>

          <TableCell size="small" align="center" className={classes.celda}>
            -
          </TableCell>
          <TableCell size="small" align="center" className={classes.celda}>
            -
          </TableCell>
        </>
      </TableRow>
    </React.Fragment>
  );
};

export default withRouter(memo(Row));
